import { React, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

import LinkoPaySubmit from '../../image/LinkoPaySubmit.png';

export default function LinkoSubmitModal(props) {
  const { onClickExit, onClickSubmit } = props;

  // 스크롤 제어 //
  useEffect(() => {
    document.body.style= `overflow: hidden`;
    return () => document.body.style = `overflow: auto`
  }, [])

  return (
    <TopLevelWrapper>
      <ModalView>
        <RedTrashBoxWrapper>
          <EmptyButtonWrapper/>
          <CycleBox>
            <TrashImage src={LinkoPaySubmit} />
          </CycleBox>
          <EmptyButtonWrapper/>
        </RedTrashBoxWrapper>
        <TotalWrapper>
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#232323' cursor='default'>링코페이 신청</Text>
          <TextWrapper>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#232323' cursor='default'>1. 사업자등록증 2. 통장 사본 3. 신분증 사본</Text>
          </TextWrapper>
          <TextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>계약 진행을 위해 위 서류를 준비해주시기 바랍니다.</Text>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>계약 담당자가 3 영업일 이내에 자료를 요청드릴 수 있습니다.</Text>
          </TextWrapper>
        </TotalWrapper>
        <ButtonWrapper>
          <ExitButton onClick={onClickExit}>
            닫기
          </ExitButton>
          <SubmitButton onClick={onClickSubmit}>
            신청하기
          </SubmitButton>
        </ButtonWrapper>
      </ModalView>
    </TopLevelWrapper> 
  )
}

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  justify-content: center;
  align-items: center;

  z-index: 1000;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.2);
	
	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 400px;
  height: 228px;

  border-radius: 15px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);
  background-color: #FFFFFF;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: 12px;

  width: 90.33%;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: #232323;

  margin: 0 0 0 0;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  justify-content: center;
  align-items: center;

  margin-top: 8px;
  
  // gap: 4px;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: #595959;
  
  margin: 0 0 0 0;
`;

const RedTrashBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 12px 0px 12px;
  margin-top: -43px;

  width: calc(100% - 24px);
`;

const CycleBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  min-width: 86px;
  max-width: 86px;
  width: 86px;

  min-height: 86px;
  max-height: 86px;
  height: 86px;

  border-radius: 86px;
  background-color: #6DD49E;
`;

const TrashImage = styled.img`
  width: 53px;
  height: 53px;
`;

const EmptyButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 12px;
  height: 12px;
`;

const ExitButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 36px;

  width: 12px;
  height: 12px;

  :hover {
    cursor: pointer;
  }
`;

const ExitImage = styled.img`
  width: 12px;
  height: 12px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 28px;

  width: 100%;
  height: 52px;

  overflow: hidden;

  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 50%;
  height: 100%;

  background-color: #CFCFCF;
  
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
  }
`;

const SubmitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 50%;
  height: 100%;

  background-color: #6DD49E;
  
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
  }
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 15px;
  background-color: #FF3131;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }
`;
